"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _blog = _interopRequireDefault(require("./modules/blog"));

var _navigation = _interopRequireDefault(require("./modules/navigation"));

var _pages = _interopRequireDefault(require("./modules/pages"));

var _themes = _interopRequireDefault(require("./modules/themes"));

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var _default = {
  route: _UrlPathParams.WEBSITE,
  modules: [_navigation.default, _themes.default, _pages.default, _blog.default]
};
exports.default = _default;
module.exports = exports.default;